<template>
  <div>
    <b-container class="side-n" id="">
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('customerCare')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'customerCare' }]"
          >
            APDCL Customer Care
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('kofficial')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'kofficial' }]"
          >
            Key Officials (HQ) Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('zone')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'zone' }]"
          >
            Zone Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('circle')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'circle' }]"
          >
            Circle Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('division')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'division' }]"
          >
            Division Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('subdivision')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'subdivision' }]"
          >
            Sub-Division Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('irca')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'irca' }]"
          >
            IRCA Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('tc')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'tc' }]"
          >
            T&C Division Contact Details
          </b-button>
        </b-col>
      </b-row>
      <b-row class="custom-row">
        <b-col>
          <b-button 
            @click="goto('agm')" 
            block 
            squared 
            :class="['btn-color', { 'btn-color-active': activeTab === 'agm' }]"
          >
            District-wise AGM(Project)
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ContactSideNav',
  data() {
    return {
      activeTab: 'customerCare'
    }
  },
  methods: {
    goto(refName) {
      this.activeTab = refName;

      // Cleanly pass active layout values to the main content container
      this.$root.$emit('change-contact-tab', refName);

      // Keep the deep link fallback intact
      if (window.location.hash !== '#' + refName) {
        window.location.hash = refName;
      }
    }
  },
  mounted() {
    // If the mobile dropdown changes the view, synchronize the sidebar highlight state
    this.$root.$on('change-contact-tab', (sectionId) => {
      this.activeTab = sectionId;
    });

    // Check URL hashes on initial page loading
    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (['customerCare', 'kofficial', 'zone', 'circle', 'division', 'subdivision', 'irca', 'tc', 'agm'].includes(hash)) {
        this.activeTab = hash;
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('change-contact-tab');
  }
}
</script>

<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;
}

.btn-color{
  color: #616161;
  background-color: #ffff;
  border-color: #e0e0e0;
  transition:0.3s;
}
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd;
  border-color: #0277bd;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1 !important;
  border-color: #0288d1 !important;
  box-shadow: none;
}

.side-n{
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  width:100%;
  overflow-y: auto;
  max-height: calc(100vh - 150px);
}

.container,.col
{
  padding-left:0;
  padding-right: 0;
}
</style>